import { useEffect } from "react";

export function useModalLockScroll(isOpen: boolean) {
  useEffect(() => {
    const handleTouchMove = (e: TouchEvent) => {
      if (isOpen) {
        e.preventDefault(); // chặn scroll background trên mobile
      }
    };

    if (isOpen) {
      // khóa scroll cho body
      document.body.style.overflow = "hidden";

      // chặn touchmove trên iOS
      document.body.addEventListener("touchmove", handleTouchMove, { passive: false });
    } else {
      // mở lại scroll khi modal đóng
      document.body.style.overflow = "";
      document.body.removeEventListener("touchmove", handleTouchMove);
    }

    return () => {
      // cleanup khi component unmount
      document.body.style.overflow = "";
      document.body.removeEventListener("touchmove", handleTouchMove);
    };
  }, [isOpen]);
}
